import Blog from "./Blog";
import styles from "../../styles/Blog/Blog.module.css";

const FeaturedThisMonth = ({blogs = []}) => {
  return (
    <div>
      <div className={styles.featuredTitle}>Featured This Month</div>
      <div
        style={{
          display: "flex",
          gap: "20px",
          flexDirection: "column",
          marginTop: "2em",
        }}
      >
        {blogs.length > 0 ? (
          blogs.map((blog) => <Blog key={blog["blogId"]} data={blog} />)
        ) : (
          <p>No blogs available this month.</p>
        )}
      </div>
    </div>
  );
};

export default FeaturedThisMonth;
